import React from 'react';
import {Col, Row} from 'react-bootstrap';

import {StreamBankChartLegendItem} from "./StreamBankChartLegendItem";

export function StreamBankChartLegend(props) {
    if(!props.Data) {
        return null;
    }
    
    return <Row className="sb-chart-legend">
        {
            props.Series.map((series) => {
                let dataset = props.Data.datasets.find((x) => x.label === series.label );
                if(!dataset) {
                    dataset = {
                        enabled: false,
                        backgroundColor: "#CCC",
                        borderColor: "#CCC",
                        label: series.key,
                        key: series.key
                    };
                }

                return <Col key={dataset.label} xs={12}>
                    <StreamBankChartLegendItem DataSet={dataset} OnClick={props.OnClick}
                                               Enabled={series.enabled}
                                               EnvironmentalBenefit={props?.EnvironmentalBenefit}
                    />
                </Col>;
            })
        }
    </Row>;
};

